export default {
  newConference: 'New Conference',
  dialInNumber: 'Dial-in Number',
  host: 'Host',
  participants: 'Participants',
  internationalParticipants: 'International participants',
  internationalNumbersHeader: 'Select International Dial-in Numbers',
  search: 'Search...',
  inviteWithText: 'Invite with Text',
  inviteText: 'Please join the RingCentral conference.\n\nDial-In Numbers: {dialInNumber} \n\n{internationals} \nParticipant Access: {participantCode} \n\nNeed an international dial-in phone number? Please visit http://www.ringcentral.com/conferencing \n\nThis conference call is brought to you by RingCentral Conferencing.'
};
